import { GymTypes } from 'fitbeat.models';
import {
    CardioOrResistance, Exercise,
    ExerciseFormat, MotivationalVoiceTipType,
} from '../../../entities/exercise/exercise';
import { IExerciseRepository } from '../../../persistence';
import { SpecialFormatExerciseSelector } from './SpecialFormatExerciseSelector';

export class VoiceTipsSelector {

    public static async getMotiTipsForToday(
        exerciseRepository: IExerciseRepository, gymType: GymTypes, date: Date, instructor: string)
        : Promise<Map<string, { [key: string]: Exercise[] }>> {

        const allExercises = await exerciseRepository.getAll();
        const motiTipsForFormats = new Map<string, { [key: string]: Exercise[] }>();
        motiTipsForFormats.set(CardioOrResistance.Resistance,
            {
                [MotivationalVoiceTipType.MotivQ1]: SpecialFormatExerciseSelector.filterMotiTips(
                    allExercises, gymType, date, ExerciseFormat.MotivBuildQ1, instructor),
                [MotivationalVoiceTipType.MotivQ2]: SpecialFormatExerciseSelector.filterMotiTips(
                    allExercises, gymType, date, ExerciseFormat.MotivBuildQ2, instructor),
                [MotivationalVoiceTipType.MotivQ3]: SpecialFormatExerciseSelector.filterMotiTips(
                    allExercises, gymType, date, ExerciseFormat.MotivBuildQ3, instructor),
            },
        );
        motiTipsForFormats.set(CardioOrResistance.Cardio,
            {
                [MotivationalVoiceTipType.MotivQ1]: SpecialFormatExerciseSelector.filterMotiTips(
                    allExercises, gymType, date, ExerciseFormat.MotivBurnQ1, instructor),
                [MotivationalVoiceTipType.MotivQ2]: SpecialFormatExerciseSelector.filterMotiTips(
                    allExercises, gymType, date, ExerciseFormat.MotivBurnQ2, instructor),
                [MotivationalVoiceTipType.MotivQ3]: SpecialFormatExerciseSelector.filterMotiTips(
                    allExercises, gymType, date, ExerciseFormat.MotivBurnQ3, instructor),
            },
        );
        motiTipsForFormats.set(CardioOrResistance.Balance,
            {
                [MotivationalVoiceTipType.MotivQ1]: SpecialFormatExerciseSelector.filterMotiTips(
                    allExercises, gymType, date, ExerciseFormat.MotiveBalanceQ1, instructor),
                [MotivationalVoiceTipType.MotivQ2]: [],
                [MotivationalVoiceTipType.MotivQ3]: SpecialFormatExerciseSelector.filterMotiTips(
                    allExercises, gymType, date, ExerciseFormat.MotiveBalanceQ3, instructor),
            },
        );

        return motiTipsForFormats;
    }
}
